module.exports = __webpack_public_path__ + "img/logo-umy.52f757e0.png";